import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../lib/auth";
import { ROLE_LABELS } from "../lib/roles";

export default function Forbidden() {
    const { user } = useAuth();
    return (
        <div className="min-h-screen flex items-center justify-center p-8">
            <div className="max-w-lg text-center">
                <ShieldAlert className="h-12 w-12 mx-auto text-[color:var(--brand-coral)]" />
                <h1 className="font-display text-5xl mt-4">403 · Acceso restringido</h1>
                <p className="text-muted-foreground mt-3">
                    Tu rol{" "}
                    {(user?.roles || [])
                        .map((r) => ROLE_LABELS[r] || r)
                        .join(", ") || "sin roles"}{" "}
                    no tiene permisos para esta sección. Contacta a Admin TI.
                </p>
                <Button asChild className="mt-6">
                    <Link to="/dashboard">Volver al Dashboard</Link>
                </Button>
            </div>
        </div>
    );
}
